import { useCallback } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { Empty } from 'google-protobuf/google/protobuf/empty_pb';
import { TGRPCPromiseReject } from '@monorepo/grpc';
import { QUERY_KEYS } from '@monorepo/helpers';
import { useSiteSettings } from '@monorepo/site-settings';
import { REQUEST_TYPES, useGetRequest } from '@monorepo/requests';

const useLogoutMutation = () => {
  const queryClient = useQueryClient();
  const { generalRoutes } = useSiteSettings();
  const { login } = generalRoutes;
  const navigate = useNavigate();
  const logout = useGetRequest(REQUEST_TYPES.LOGOUT);

  const onSuccess = useCallback(() => {
    queryClient.resetQueries({
      queryKey: [QUERY_KEYS.CHECK_SESSION]
    });
  }, [queryClient, navigate, login]);

  return useMutation<Empty.AsObject | null, TGRPCPromiseReject>({
    mutationFn: logout,
    retry: false,
    onSuccess
  });
};

export default useLogoutMutation;
